import { PaymentStatus, type PaymentGateway } from "@/types/form-types"
import { toast } from "sonner"

declare global {
	interface Window {
		EasebuzzCheckout: new (accessKey: string, mode: string) => any
	}
}

export const EasebuzzGateway: PaymentGateway = {
	async initPayment({
		// amount,
		// applicationId,
		setValues,
		access_key,
		modeEazebuzz,
		setShowPaymentGateway,
		showPaymentGatewayRef,
	}) {
		const accessKey = access_key
		modeEazebuzz = modeEazebuzz === "UAT" ? "test" : "prod"

		// load script if not already loaded
		await new Promise((resolve, reject) => {
			if ((window as any).EasebuzzCheckout) return resolve(true)
			const script = document.createElement("script")
			script.src =
				"https://ebz-static.s3.ap-south-1.amazonaws.com/easecheckout/v2.0.0/easebuzz-checkout-v2.min.js"
			script.async = true
			script.onload = () => resolve(true)
			script.onerror = () =>
				reject(new Error("Failed to load easebuzz SDK"))
			document.body.appendChild(script)
		})

		const easebuzzCheckout = new window.EasebuzzCheckout(
			accessKey,
			modeEazebuzz,
		)
		const options = {
			access_key: accessKey,
			onResponse: (response: any) => {
				if (response.status === "userCancelled") {
					toast.error("Your payment is been cancelled")
					// onComplete?.({
					// 	orderId,
					// 	transactionId,
					//  status: "PAYMENT_CANCELLED",
					// })
					setShowPaymentGateway(true)
					showPaymentGatewayRef.current = true
					setValues({
						payment_status:
							PaymentStatus.PAYMENT_FAILED_RETRY_ALLOWED,
					})
					return
				}
				if (response.status === "success") {
					// onComplete?.({
					// 	orderId: response.udf1,
					// 	transactionId: response.txnid,
					//  status: "PAYMENT_SUCCESS",
					// 	amount,
					// 	gateway_response: response,
					// })\
					// setValues({
					// 	payment_status: PaymentStatus.PAYMENT_SUCCESS,
					// 	transaction_id: response.txnid,
					// 	order_id: response.udf1,
					// })
					// window.location.reload()
				} else {
					// onComplete?.({
					// 	orderId,
					// 	transactionId,
					//  status: "PAYMENT_FAILED",
					// 	gateway_response: response,
					// })
					setShowPaymentGateway(true)
					showPaymentGatewayRef.current = true

					setValues({
						payment_status:
							PaymentStatus.PAYMENT_FAILED_RETRY_ALLOWED, //need to check the logic
					})
				}

				//temporary
				// window.location.reload()
			},
			theme: "#123456",
		}
		easebuzzCheckout.initiatePayment(options)
	},
}
